export const environment = {
  production: true,
  clientId: 'blud-resource-server',
  clientSecret: '123456',
  uriApi: '/api-server',
  uriAuth: '/auth-server',
  uriReport: '/rba-report',
  uriExcelReader: '/excel-reader-server'
};
